/**
 * FED Fitness 首页自定义埋点库（L3 业务事件）
 *
 * 依据《FED 埋点需求 PRD》与《埋点命名与参数规范》实现：
 * - 事件命名：fed_ 前缀 + 对象_动作（snake_case）
 * - 数据层：window.dataLayer（GTM-K425GVD4 已配置默认 dataLayer）
 * - 页面级统一参数（page_type / device / login_status）由 theme.liquid 以
 *   顶层键值方式推入 dataLayer，由 GTM 统一注入事件
 * - 公共参数 page_url 由本文件在每次上报时实时注入（取 window.location.href，去 hash）
 *
 * 埋点约定（通过 HTML data 属性声明式埋点）：
 * - data-fed-view="事件名"           曝光：元素 50%+ 进入视口并停留 ≥1s，触发一次
 * - data-fed-click="事件名"          点击：元素（或其祖先）被点击时触发
 * - data-fed-add-to-cart="事件名"    加购点击：优先于 data-fed-click 判定
 * - data-fed-hover="事件名"          悬停：PC 指针悬停 ≥0.5s，每元素触发一次
 * - data-fed-product-track          产品卡片容器：自动区分点击/加购并触发
 *                                    fed_item_click / fed_item_add_to_cart
 * - data-fed-nav                    导航容器：内部 <a> / 可展开 <summary> 点击触发 fed_nav_click
 *                                   一级 <li> 悬停触发 fed_nav_hover
 * - data-fed-nav-toggle             汉堡菜单开关：触发 fed_nav_open / fed_nav_close
 * - data-fed-footer                 页脚容器：内部导航链接/社交图标触发 fed_footer_click
 * - data-fed-subscribe              订阅表单：提交触发 fed_footer_subscribe
 * 业务参数：data-fed-p-<参数名>（snake_case，如 data-fed-p-product_id）
 * 数字/布尔自动转换。
 */
(function () {
  'use strict';

  var CONTEXT = window.FEDTrackContext || {};

  /**
   * 生产环境开关（第二道防线）：
   * 开关由 layout/theme.liquid 依据 request.host（www.fedfitness.com / fedfitness.com）
   * 且非主题编辑器模式（request.design_mode == false）判定，并输出到 <body data-fed_track_enabled="...">。
   * 其他主题（GitHub 分支自动同步的开发 / 预览主题）该值为 false，即便脚本被加载也直接退出，
   * 不注册任何监听、不上报任何 fed_* 事件，避免污染 GA4。
   */
  if (CONTEXT.enabled !== true) return;

  /** 当前页面 URL（公共参数），去掉 hash，随每次上报实时取值 */
  function currentPageUrl() {
    try {
      var href = window.location.href || '';
      var hashIndex = href.indexOf('#');
      return hashIndex === -1 ? href : href.slice(0, hashIndex);
    } catch (e) {
      return '';
    }
  }

  /**
   * 推送事件到 dataLayer。
   * 每次上报都会附带公共参数 page_url，且不允许业务参数覆盖。
   * @param {string} event 事件名
   * @param {object} params 业务参数（空值剔除）
   */
  function push(event, params) {
    var payload = { event: event };
    if (params && typeof params === 'object') {
      Object.keys(params).forEach(function (k) {
        var v = params[k];
        if (v !== undefined && v !== null && v !== '') {
          payload[k] = v;
        }
      });
    }
    payload.page_url = currentPageUrl();
    window.dataLayer.push(payload);
    return payload;
  }

  window.FEDTrack = window.FEDTrack || {};
  window.FEDTrack.push = push;
  window.FEDTrack.context = CONTEXT;
  // 供 section 内轮播/视频 JS 调用
  window.FEDTrack.slide = function (event, params) {
    return push(event, params);
  };

  /* ---------- 工具 ---------- */
  function readParams(el) {
    var params = {};
    if (!el || !el.attributes) return params;
    var attrs = el.attributes;
    var prefix = 'data-fed-p-';
    for (var i = 0; i < attrs.length; i++) {
      var name = attrs[i].name;
      if (name.indexOf(prefix) !== 0) continue;
      var key = name.slice(prefix.length);
      var val = attrs[i].value;
      if (/^-?\d+(\.\d+)?$/.test(val)) {
        val = Number(val);
      } else if (val === 'true') {
        val = true;
      } else if (val === 'false') {
        val = false;
      }
      params[key] = val;
    }
    return params;
  }

  /** 从 target 向上找第一个带指定属性的元素 */
  function closest(el, attr) {
    while (el && el.getAttribute) {
      if (el.hasAttribute(attr)) return el;
      el = el.parentElement;
    }
    return null;
  }

  function isMobileEnv() {
    return window.matchMedia && window.matchMedia('(max-width: 1024px)').matches;
  }

  function cartCount() {
    var el = document.querySelector('.cart-count-bubble [aria-hidden="true"]');
    if (!el) return 0;
    var n = parseInt(el.textContent.replace(/\D/g, ''), 10);
    return isNaN(n) ? 0 : n;
  }

  function platformFromUrl(url) {
    var host = '';
    try {
      host = new URL(url, window.location.origin).hostname;
    } catch (e) {
      return '';
    }
    var map = {
      facebook: 'facebook',
      instagram: 'instagram',
      youtube: 'youtube',
      tiktok: 'tiktok',
      twitter: 'twitter',
      x: 'twitter',
      pinterest: 'pinterest',
      snapchat: 'snapchat',
      tumblr: 'tumblr',
      vimeo: 'vimeo',
    };
    for (var k in map) {
      if (host.indexOf(k) !== -1) return map[k];
    }
    return host;
  }

  function inferMenuLevel(a) {
    var c = typeof a.className === 'string' ? a.className : '';
    if (c.indexOf('mega-menu__link--level-2') !== -1) return 2;
    if (c.indexOf('mega-menu__link') !== -1) return 3;
    if (a.closest('.level-menu-3')) return 3;
    if (a.closest('.accordion-content, .mega-menu')) return 2;
    if (c.indexOf('header__menu-item') !== -1 || c.indexOf('list-menu__item') !== -1) return 1;
    return 1;
  }

  /**
   * 移动端抽屉（.accordion-menu）层级推断：按 DOM 结构判定，
   * 业务模板（header-drawer.liquid）内无需逐层写埋点属性。
   */
  function drawerMenuLevel(el) {
    // 可展开项：summary 自身即菜单项（无 href）
    if (el.tagName === 'SUMMARY') {
      if (el.closest('.accordion-third-level')) return 3;
      if (el.closest('.accordion-sub-item')) return 2;
      return 1;
    }
    if (el.closest('.level-menu-4')) return 4;
    if (el.closest('.level-menu-3')) return 3;
    if (el.closest('.single_content_mob, .accordion-content')) return 2;
    return 1;
  }

  function menuLevelOf(el) {
    var attr = el.getAttribute('data-fed-menu-level');
    if (attr) return Number(attr) || attr;
    if (el.closest('.accordion-menu')) return drawerMenuLevel(el);
    return inferMenuLevel(el);
  }

  function menuText(el) {
    var own = el.getAttribute('data-fed-menu-name');
    if (own) return own;
    var named = el.querySelector('[data-fed-menu-name]');
    if (named) return named.getAttribute('data-fed-menu-name') || '';
    var titleEl = el.querySelector('.accordion-summary__title') || el.querySelector('span');
    return ((titleEl || el).textContent || '').trim().replace(/\s+/g, ' ').slice(0, 80);
  }

  /* ---------- 曝光 ---------- */
  var VIEW_RATIO = 0.5;
  var VIEW_HOLD = 1000;

  function isHalfVisible(el) {
    var r = el.getBoundingClientRect();
    var vw = document.documentElement.clientWidth;
    var vh = document.documentElement.clientHeight;
    if (!r.width || !r.height) return false;
    var iw = Math.min(r.right, vw) - Math.max(r.left, 0);
    var ih = Math.min(r.bottom, vh) - Math.max(r.top, 0);
    if (iw <= 0 || ih <= 0) return false;
    return (iw * ih) / (r.width * r.height) >= VIEW_RATIO;
  }

  function initViewTracking() {
    var els = document.querySelectorAll('[data-fed-view]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        push(el.getAttribute('data-fed-view'), readParams(el));
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var el = entry.target;
          if (!entry.isIntersecting) {
            if (el.__fedViewTimer) {
              clearTimeout(el.__fedViewTimer);
              el.__fedViewTimer = null;
            }
            return;
          }
          if (el.__fedViewed || el.__fedViewTimer) return;
          el.__fedViewTimer = setTimeout(function () {
            el.__fedViewTimer = null;
            if (!isHalfVisible(el)) return;
            el.__fedViewed = true;
            push(el.getAttribute('data-fed-view'), readParams(el));
            io.unobserve(el);
          }, VIEW_HOLD);
        });
      },
      { threshold: VIEW_RATIO }
    );
    els.forEach(function (el) {
      io.observe(el);
    });
  }

  /* ---------- 悬停 ---------- */
  var HOVER_HOLD = 500;

  function initHoverTracking() {
    document.querySelectorAll('[data-fed-hover]').forEach(function (el) {
      var timer = null;
      el.addEventListener('mouseenter', function () {
        if (el.__fedHovered) return;
        timer = setTimeout(function () {
          el.__fedHovered = true;
          push(el.getAttribute('data-fed-hover'), readParams(el));
        }, HOVER_HOLD);
      });
      el.addEventListener('mouseleave', function () {
        if (timer) {
          clearTimeout(timer);
          timer = null;
        }
      });
    });
  }

  /* ---------- 导航悬停 ---------- */
  var NAV_HOVER_HOLD = 500;

  function navMenuName(item) {
    var el = item.querySelector('[data-fed-menu-name]');
    if (el) return el.getAttribute('data-fed-menu-name') || '';
    var textEl = item.querySelector('summary, a');
    if (!textEl) return '';
    return (textEl.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 80);
  }

  function navTargetUrl(item) {
    var el = item.querySelector('[data-fed-menu-url]');
    if (el) return el.getAttribute('data-fed-menu-url') || '';
    var link = item.querySelector('a[href]');
    if (!link) return '';
    return link.getAttribute('href') === '#' ? '' : link.href;
  }

  function initNavHoverTracking() {
    document.querySelectorAll('[data-fed-nav]').forEach(function (nav) {
      nav.querySelectorAll(':scope > li').forEach(function (item) {
        var timer = null;
        item.addEventListener('mouseenter', function () {
          if (item.__fedNavHovered || timer) return;
          timer = setTimeout(function () {
            timer = null;
            item.__fedNavHovered = true;
            push('fed_nav_hover', {
              menu_name: navMenuName(item),
              menu_level: 1,
              target_url: navTargetUrl(item),
            });
          }, NAV_HOVER_HOLD);
        });
        item.addEventListener('mouseleave', function () {
          if (timer) {
            clearTimeout(timer);
            timer = null;
          }
        });
      });
    });
  }

  /* ---------- 点击 ---------- */
  var ADD_TO_CART_SELECTOR =
    '.quick-add__submit, .aux-choose-options, .option-button';

  function handleClick(e) {
    var target = e.target;
    if (!target || !target.getAttribute) return;

    // 1) 显式加购点击
    var atcEl = closest(target, 'data-fed-add-to-cart');
    if (atcEl) {
      push(atcEl.getAttribute('data-fed-add-to-cart'), readParams(atcEl));
      return;
    }

    // 2) 显式点击
    var clickEl = closest(target, 'data-fed-click');
    if (clickEl) {
      var eventName = clickEl.getAttribute('data-fed-click');
      // 搜索框：展开时记录，收起（再次点击）不记录
      if (eventName === 'fed_search_open') {
        var searchDetails = clickEl.closest('details');
        if (searchDetails && searchDetails.open) return;
      }
      var params = readParams(clickEl);
      // 购物车：实时读取购物车数量
      if (eventName === 'fed_cart_open' && !params.cart_count) {
        params.cart_count = cartCount();
      }
      push(eventName, params);
      return;
    }

    // 3) 产品卡片（产品推荐 / 明星产品）
    var card = closest(target, 'data-fed-product-track');
    if (card) {
      // 变体选择弹窗：仅提交加购计入，其余（关闭/选规格）不记录
      var modal = target.closest('.quick-add-modal');
      if (modal) {
        if (!target.closest(ADD_TO_CART_SELECTOR)) return;
        var modalParams = readParams(card);
        modalParams.quantity = 1;
        push('fed_item_add_to_cart', modalParams);
        return;
      }
      var params = readParams(card);
      var isAtc = !!target.closest(ADD_TO_CART_SELECTOR);
      if (isAtc) {
        params.quantity = 1;
        push('fed_item_add_to_cart', params);
      } else {
        push('fed_item_click', params);
      }
      return;
    }

    // 4) 导航菜单点击：链接 + 可展开的 summary（抽屉各级由 DOM 推断层级）
    var nav = closest(target, 'data-fed-nav');
    if (nav) {
      var navEl = target.closest('a[href], summary');
      // 抽屉内商品卡不按导航点击记录
      if (navEl && !navEl.closest('.menu-drawer-products-carousel')) {
        var isSummary = navEl.tagName === 'SUMMARY';
        var navHref = navEl.getAttribute('href');
        if (isSummary || (navHref && navHref !== '#')) {
          push('fed_nav_click', {
            menu_name: menuText(navEl),
            menu_level: menuLevelOf(navEl),
            target_url: isSummary ? '' : navEl.href,
          });
        }
      }
      return;
    }

    // 5) 汉堡菜单开/关
    var toggle = closest(target, 'data-fed-nav-toggle');
    if (toggle) {
      var detailsEl = toggle.closest('details');
      if (detailsEl) {
        push(detailsEl.open ? 'fed_nav_close' : 'fed_nav_open', {});
      }
      return;
    }

    // 6) 页脚点击（导航链接 / 社交图标）
    var footer = closest(target, 'data-fed-footer');
    if (footer) {
      var socialLink = target.closest('a.list-social__link');
      if (socialLink) {
        push('fed_footer_click', {
          element_name: 'social_icon',
          section_title: 'social',
          target_url: socialLink.href,
          platform: platformFromUrl(socialLink.href),
        });
        return;
      }
      var footerLink = target.closest('a[href]');
      if (footerLink && footerLink.getAttribute('href') !== '#') {
        var list = footerLink.closest('ul.footer-block__details-content, .footer_item_mob');
        if (list) {
          var holder = list.closest('.footer-block, .footer_item_mob');
          var headingEl = holder ? holder.querySelector('.footer-block__heading, h2') : null;
          push('fed_footer_click', {
            element_name: (footerLink.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 80),
            section_title: headingEl ? headingEl.textContent.trim().slice(0, 60) : '',
            target_url: footerLink.href,
            platform: '',
          });
          return;
        }
      }
    }
  }

  function initClickTracking() {
    // capture 阶段执行，先于业务脚本的 stopPropagation
    document.addEventListener('click', handleClick, true);
  }

  /* ---------- 订阅（页脚） ---------- */
  function initSubscribeTracking() {
    document.querySelectorAll('[data-fed-subscribe]').forEach(function (form) {
      // 页面加载后若已存在成功提示（表单提交后整页刷新），补记成功事件
      var successEl = form.querySelector('.newsletter-form__message--success');
      if (successEl && !form.__fedSubscribeSuccess) {
        form.__fedSubscribeSuccess = true;
        push('fed_footer_subscribe', {
          email_domain: emailDomain(form),
          subscribe_status: 'success',
        });
      }
      form.addEventListener('submit', function () {
        push('fed_footer_subscribe', {
          email_domain: emailDomain(form),
          subscribe_status: 'submitted',
        });
      });
    });
  }

  function emailDomain(form) {
    var input = form ? form.querySelector('input[type="email"]') : null;
    if (!input || !input.value) return '';
    var at = input.value.indexOf('@');
    if (at === -1) return '';
    return input.value.slice(at + 1).toLowerCase();
  }

  /* ---------- 初始化 ---------- */
  function init() {
    initViewTracking();
    initClickTracking();
    initHoverTracking();
    initNavHoverTracking();
    initSubscribeTracking();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
